import {cn} from '@/lib/utils'
import React from 'react'
import {WuLoader} from '../loader'

export interface IWuFooterProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
  isLoading?: boolean
  loadingText?: string
  children?: React.ReactNode
}

export const WuFooter: React.FC<IWuFooterProps> = ({
  className,
  isLoading,
  loadingText,
  children,
  ...props
}) => {
  return (
    <footer
      className={cn(
        'flex items-center justify-between gap-2 border-t border-gray-10 py-3 px-4 bg-white/80 backdrop-blur-sm text-xs font-normal text-gray-footer sticky bottom-0',
        className,
      )}
      {...props}
    >
      <div className="flex-1">{children}</div>
      {isLoading && (
        <WuLoader
          size="16px"
          variant="spinner"
          color="#a3a3a3"
          message={loadingText}
        />
      )}
    </footer>
  )
}

WuFooter.displayName = 'WuFooter'
